export default "__VITE_ASSET__Ykw7pKTb__"